const Prices = (domEl) => {

	if(!domEl) {
		return ;
	}


	// Elements
	const heading = domEl.querySelector('.price-item-heading');
	const content = domEl.querySelector('.price-item-content');

	// State
	let isOpen = false;

	// Methods
	const open = () => {
		isOpen = true;
		domEl.classList.add('is-open');
		content.style.display = 'block';
		// Use setTimeout to ensure display: block is applied before animation
		setTimeout(() => {
			content.style.height = content.scrollHeight + 'px';
		}, 1);
	};

	const close = () => {
		isOpen = false;
		domEl.classList.remove('is-open');
		content.style.height = '0';
		// Wait for animation to complete before setting display none
		content.addEventListener('transitionend', () => {
			if(!isOpen) { // Check the state again in case it was reopened during animation
				content.style.display = 'none';
			}
		}, { once: true });
	};

	const toggle = () => {
		if(isOpen) {
			close();
		}
		else {
			open();

			// Close adjacent accordions
			let sibling = domEl;

			// Close previous adjacent accordions
			while(sibling.previousElementSibling &&
			sibling.previousElementSibling.matches('.acf-block-prices') &&
			!sibling.previousElementSibling.matches('p, div:not(.acf-block-prices)')) {
				const accordionHead = sibling.previousElementSibling.querySelector('.acf-block-accordion-heading');
				if(sibling.previousElementSibling.classList.contains('is-open')) {
					accordionHead.click();
				}
				sibling = sibling.previousElementSibling;
			}

			// Close next adjacent accordions
			sibling = domEl;
			while(sibling.nextElementSibling &&
			sibling.nextElementSibling.matches('.acf-block-prices') &&
			!sibling.nextElementSibling.matches('p, div:not(.acf-block-prices)')) {
				const accordionHead = sibling.nextElementSibling.querySelector('.acf-block-accordion-heading');
				if(sibling.nextElementSibling.classList.contains('is-open')) {
					accordionHead.click();
				}
				sibling = sibling.nextElementSibling;
			}
		}
	};

	// Update height on resize if accordion is open
	const updateHeight = () => {
		if(isOpen) {
			// Temporarily remove transition and height to get true scrollHeight
			const currentTransition = content.style.transition;
			const currentHeight = content.style.height;
			content.style.transition = 'none';
			content.style.height = 'auto';

			// Get the new scrollHeight
			const newHeight = content.scrollHeight;

			// Reset to previous height without transition
			content.style.height = currentHeight;

			// Force reflow
			content.offsetHeight;

			// Set new height and restore transition
			content.style.transition = currentTransition;
			content.style.height = newHeight + 'px';
		}
	};

	// Initialize
	const init = () => {
		// Set initial styles for animation
		content.style.height = '0';
		content.style.overflow = 'hidden';
		content.style.transition = 'height 0.3s ease-out';

		// Add click handler
		heading.addEventListener('click', toggle);

		// Add resize handler with debouncing
		let resizeTimeout;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(updateHeight, 1);
		});
	};

	init();

	return {
		open,
		close,
		toggle
	};
};

export default Prices;